import React from "react";
import cx from "classnames";

import { useMigrationCountdown } from "../../../hooks/useMigrationCountdown";

import * as styles from "./MigrationCountdown.module.scss";

const pad = (value: number) => String(value).padStart(2, "0");

const UNITS = [
  { key: "days", label: "Days" },
  { key: "hours", label: "Hours" },
  { key: "minutes", label: "Minutes" },
  { key: "seconds", label: "Seconds" },
] as const;

interface MigrationCountdownProps {
  variant?: "hero" | "banner";
  className?: string;
}

const MigrationCountdown: React.FC<MigrationCountdownProps> = ({
  variant = "hero",
  className,
}) => {
  const countdown = useMigrationCountdown();

  return (
    <div
      className={cx(
        styles.MigrationCountdown,
        styles[`MigrationCountdown_${variant}`],
        className
      )}
      aria-label="Time remaining until 31 July 2026"
    >
      {UNITS.map((unit, index) => (
        <React.Fragment key={unit.key}>
          {index > 0 && (
            <span
              className={cx(
                styles.MigrationCountdown_separator,
                variant === "banner" && styles.MigrationCountdown_separator_banner
              )}
            >
              :
            </span>
          )}
          <div
            className={cx(
              styles.MigrationCountdown_unit,
              variant === "banner" && styles.MigrationCountdown_unit_banner
            )}
          >
            <span
              className={cx(
                styles.MigrationCountdown_value,
                styles[`MigrationCountdown_value_${variant}`]
              )}
            >
              {pad(countdown[unit.key])}
            </span>
            <span
              className={cx(
                styles.MigrationCountdown_label,
                variant === "banner" && styles.MigrationCountdown_label_banner
              )}
            >
              {unit.label}
            </span>
          </div>
        </React.Fragment>
      ))}
    </div>
  );
};

export default MigrationCountdown;
